var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4bbb46;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.07,
    cy: 11.07,
    r: 11.07,
    transform: "translate(0.93 0.93)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,24A12,12,0,1,1,24,12,12.014,12.014,0,0,1,12,24ZM12,1.859A10.141,10.141,0,1,0,22.141,12,10.152,10.152,0,0,0,12,1.859Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.426,170.655a.928.928,0,0,1-.663-.278l-3.43-3.486a.929.929,0,1,1,1.325-1.3l2.74,2.785,5.669-6.244a.929.929,0,1,1,1.376,1.25l-6.33,6.971a.93.93,0,0,1-.669.3Z",
    transform: "translate(-125.876 -154.239)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8706abd922010f642a73cf6ad2be41fd.svg";
export { ForwardRef as ReactComponent };